import { Box } from '@mui/material'
import UsersListComponent from '../components/UsersListComponent'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import UserInfoComponent from '../components/UserInfoComponent'

const usersSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.users,
)

function Members() {
  const users = useSelector(usersSelector) ?? []
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null)
  const selectedUser = users.find((user) => user.id === selectedUserId)

  const handleUserClick = (userId: number) => {
    setSelectedUserId(userId)
  }

  return (
    <Box
      gap='1rem'
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100% - 3rem)',
          width: '60%',
          boxSizing: 'border-box',
          mt: '2rem',
          pt: '1rem',
          gap: '1rem',
          borderTop: 1,
          borderColor: 'divider',
        }}
      >
        <UsersListComponent
          users={users}
          selectedUserId={selectedUserId}
          hanldeUserClick={handleUserClick}
        />
      </Box>
      {!!selectedUserId && selectedUser && (
        <Box
          sx={{
            display: 'flex',
            flex: 1,
          }}
        >
          <UserInfoComponent user={selectedUser} />
        </Box>
      )}
    </Box>
  )
}

export default Members
